type SystemEventDetail = Record<string, unknown>;
type SystemEventHandler = (detail: SystemEventDetail) => void;

const handlers = new Map<string, Set<SystemEventHandler>>();

/**
 * Un evento técnico que puede interesarle a algún tracker, sin que quien lo
 * dispara sepa quién (si alguien) lo está escuchando ahora ni qué hace con
 * él. Sirve para lo que pasa seguido y no es un malfuncionamiento del
 * sistema (por ejemplo, una interrupción de red durante el long-poll del
 * chat): no va a `system_errors` — ver `services/appwrite/report-client-error.ts`
 * para eso —, pero tampoco puede desaparecer en silencio.
 */
export function emitSystemEvent(name: string, detail: SystemEventDetail = {}): void {
  handlers.get(name)?.forEach((handler) => handler(detail));
}

/**
 * Escucha un evento. Devuelve la función para dejar de hacerlo — desconectar
 * un tracker es dejar de llamar a esto, no tocar el sitio que dispara el
 * evento.
 */
export function onSystemEvent(name: string, handler: SystemEventHandler): () => void {
  const set = handlers.get(name) ?? new Set();
  set.add(handler);
  handlers.set(name, set);
  return () => {
    set.delete(handler);
  };
}
